export default __webpack_public_path__ + "images/MU.c9164df.png";